import { createRouter, createWebHistory } from 'vue-router';
import store from './store';
import VueCookies from 'vue-cookies';
import jwtDecode from 'jwt-decode';

import Signin from './views/Signin';
import Signup from './views/Signup';
import Search from './views/Search';

import ManageTemplates from './views/ManageTemplates';

import SettingsManageProfile from './views/settings/ManageProfile';
import SettingsManageLanguage from './views/settings/ManageLanguage';
import SettingsManageQuests from './views/settings/ManageQuests';
import SettingsManagePromote from './views/settings/Promote';
import SettingsTermsOfService from './views/settings/TermsOfService';
import SettingsPrivacyPolicy from './views/settings/PrivacyPolicy';
import SettingsLegalNotices from './views/settings/LegalNotices';
import SettingsCookieManagementPolicy from './views/settings/CookieManagementPolicy';
import SettingsManageAccessRoles from './views/settings/ManageAccessRoles';
import SettingsManageMembers from './views/settings/ManageMembers';
import SettingsManageSubCommunities from './views/settings/ManageSubCommunities';
import SettingsManageAccount from './views/settings/ManageAccount';
import SettingsChannel from './views/settings/Channel';
import Protected from './views/Protected.vue';
import Expired from './views/Expired.vue';
import MultiAuth from './views/MultiAuth.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/templates/basic' },
    { path: '/signin', component: Signin },
    { path: '/signup', component: Signup },
    { path: '/search', component: Search },
    { path: '/templates/basic', component: ManageTemplates },
    { path: '/templates/community', component: ManageTemplates },
    {
      path: '/templates/participation',
      component: ManageTemplates,
    },
    {
      path: '/templates/ticket',
      component: ManageTemplates,
    },
    { path: '/templates/membership', component: ManageTemplates },
    { path: '/templates/role', component: ManageTemplates },
    { path: '/settings/profile', component: SettingsManageProfile },
    { path: '/settings/language', component: SettingsManageLanguage },
    { path: '/settings/quests', component: SettingsManageQuests },
    { path: '/settings/promote', component: SettingsManagePromote },
    { path: '/settings/terms', component: SettingsTermsOfService },
    { path: '/settings/privacy', component: SettingsPrivacyPolicy },
    { path: '/settings/legal', component: SettingsLegalNotices },
    { path: '/settings/cookies', component: SettingsCookieManagementPolicy },
    { path: '/settings/access', component: SettingsManageAccessRoles },
    { path: '/settings/members', component: SettingsManageMembers },
    {
      path: '/settings/sub-communities',
      component: SettingsManageSubCommunities,
    },
    { path: '/settings/account', component: SettingsManageAccount },
    { path: '/settings/channel', component: SettingsChannel },
    { path: '/protected', component: Protected },
    { path: '/expired', component: Expired },
    { path: '/auth', component: MultiAuth },
    { path: '/:notFound(.*)', redirect: '/' },
  ],
});

window.onpopstate = function () {
  location.reload();
};

router.beforeEach(async (to, from, next) => {
  const token = VueCookies.get('token');

  if (process.env.VUE_APP_PASSWORD && process.env.VUE_APP_PASSWORD.length > 0) {
    // password protection
    const passwordValid =
      VueCookies.get('pwd') &&
      VueCookies.get('pwd') == process.env.VUE_APP_PASSWORD;

    if (passwordValid && to.path == '/protected') {
      return router.push('/');
    }
    if (!passwordValid) {
      VueCookies.remove('pwd');
      VueCookies.remove('token');
      if (to.path != '/protected') return router.push('/protected');
    }
  }

  store.commit(
    'setVerticalBarsDisplay',
    ['/signup', '/signin', '/protected', '/expired', '/auth'].indexOf(
      to.path
    ) == -1
  );

  if ((token && jwtDecode(token).exp < Date.now() / 1000) || !token) {
    VueCookies.remove('token');
    if (
      process.env.VUE_APP_PASSWORD &&
      process.env.VUE_APP_PASSWORD.length > 0
    ) {
      if (
        ['/signup', '/signin', '/expired', '/protected', '/auth'].indexOf(
          to.path
        ) == -1
      ) {
        return router.push('/signin');
      }
    } else {
      if (['/signup', '/signin', '/expired', '/auth'].indexOf(to.path) == -1) {
        return router.push('/signin');
      }
    }
  } else {
    if (
      process.env.VUE_APP_PASSWORD &&
      process.env.VUE_APP_PASSWORD.length > 0
    ) {
      if (
        ['/signup', '/signin', '/expired', '/protected'].indexOf(to.path) != -1
      ) {
        return router.push('/');
      }
    } else {
      if (['/signup', '/signin', '/expired'].indexOf(to.path) != -1) {
        return router.push('/');
      }
    }
  }

  return next();
});

export default router;
